import { render, staticRenderFns } from "./CallHeader.vue?vue&type=template&id=32240332&"
import script from "./CallHeader.vue?vue&type=script&lang=js&"
export * from "./CallHeader.vue?vue&type=script&lang=js&"
import style0 from "./CallHeader.vue?vue&type=style&index=0&lang=scss&scopes=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports